import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'

export function UnfilteredResults() {
  return (
    <Heading colour="neutral-eight" variant="heading1">
      Travel inspiration
    </Heading>
  )
}
